import {
  Component,
  EventEmitter,
  Output,
  Input,
  ChangeDetectionStrategy
} from "@angular/core";
import { MatMenuTrigger } from "@angular/material/menu";
import { MatDivider } from "@angular/material/list";
import { MatButton } from "@angular/material/button";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-filter-button-footer",
  templateUrl: "./filter-button-footer.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./filter-button-footer.component.scss"],
  imports: [MatDivider, MatButton, MatProgressSpinner, TranslateModule]
})
export class FilterButtonFooterComponent {
  @Output() displayMore: EventEmitter<void> = new EventEmitter();
  @Output() clearItems: EventEmitter<void> = new EventEmitter();
  @Output() applyItems: EventEmitter<boolean> = new EventEmitter();

  @Input() isNewIncident: boolean = false;
  @Input() label: string;
  @Input() type: string;
  @Input() isLoading: boolean = false;
  @Input() showAllVariant: boolean = false;
  @Input() menuTrigger: MatMenuTrigger;

  public footerType: any = {
    addIncident: "incident",
    incident: "incident",
    dateRange: "reset",
    torn: "radio",
    unknown: "radio",
    alertTypes: "radio",
    containerCategories: "radio"
  };

  constructor() {}

  public onClearItems(): void {
    this.clearItems.emit();
    this.menuTrigger?.closeMenu();
  }

  public onApplyItems(): void {
    if (this.isNewIncident) {
      this.applyItems.emit(true);
    } else {
      this.applyItems.emit();
    }
    this.menuTrigger?.closeMenu();
  }

  public onDisplayMore(): void {
    this.displayMore.emit();
  }
}
